export type DisplayMode = "grid" | "carousel" | "overlay";

export const resolveDisplayMode = (
    displayMode: "grid" | "carousel" | "overlay" | undefined,
    tileCount: number
): DisplayMode => {
    if (displayMode === "carousel" && tileCount >= 3) {
        return "carousel";
    }
    if (displayMode === "overlay") {
        return "overlay";
    }
    return "grid";
};
